import { useMessages } from "play/language/language"
import { useLocation } from "react-router-dom"
import { useEffect } from "react"
import { sendPageView } from "utils/google-analytics"

/**
 * One `page_view` per navigation in the play app. The hash is left out: it is
 * the connection id, which changes while the page stays the same and holds the
 * name of a student who is not signed in. The lesson preview is not counted: it
 * is a frame inside the editor.
 */
export default function usePlayGoogleAnalytics() {
  const { pathname, search } = useLocation()
  const { locale_code } = useMessages()

  useEffect(() => {
    if (pathname.toLowerCase().startsWith("/preview/")) return

    sendPageView(document.baseURI + pathname + search, locale_code)
  }, [pathname, search, locale_code])
}
